export default "__VITE_ASSET__DLXuJN1I__"